import { render, staticRenderFns } from "./bank_pay.vue?vue&type=template&id=2f8a811e&scoped=true&"
import script from "./bank_pay.vue?vue&type=script&lang=js&"
export * from "./bank_pay.vue?vue&type=script&lang=js&"
import style0 from "./bank_pay.vue?vue&type=style&index=0&id=2f8a811e&prod&lang=less&scoped=true&"
import style1 from "./bank_pay.vue?vue&type=style&index=1&id=2f8a811e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a811e",
  null
  
)

export default component.exports